import {SORT_BY_FIELDS} from "../data/defaults";

export type AdFilters = {
    "make"?: string;
    "model"?: string;
    "body-style"?: string;
    "fuel-type"?: string
    "colour"?: string;
    "price"?: number;
    "doors"?: number;
    "transmission"?: string;
    "geo.location"?: string;
    "geo.postcode"?: string;
    "geo.miles"?: number;
    "dealer.isApproved"?: boolean;
}

type AdSorting = {
    field?: string;
    direction?: "asc" | "desc" | string;
}

type AdPagination = {
    size?: number;
    number?: number;
}

export class RequestParams {
    filters: AdFilters = {};
    sort: AdSorting = {};
    pagination: AdPagination = {};

    constructor(filters: AdFilters, sorting: AdSorting, pagination?: AdPagination) {
        this.filters = {...filters};
        this.sort = {...sorting};
        this.pagination = {...pagination};
    }

    toString(toApiString: boolean = false, filterOutSoldCars = true) {
        const fields = Object.getOwnPropertyNames(this.filters);
        let params = new URLSearchParams();

        fields.forEach(key => {
            const value = this.filters[key as keyof AdFilters] as string | number;

            if (value && value.toString().trim() !== "") {
                if (key === "price" && toApiString) {
                    params.append(`filter[${key}][lte]`, `'${value}'`);
                } else if ((key === "geo.location" || key === "geo.miles") && toApiString) {
                    params.append(`filter[${key}]`, `${value}`);
                } else {
                    params.append(toApiString ? `filter[${key}]` : key, toApiString ?
                        `'${typeof value !== "number" ? value.replace(/'/g, "\\'") : value}'`
                        : `${value}`);
                }
            }
        });

        if (this.sort.field && this.sort.direction) {
            if (toApiString) {
                const sortFieldName = SORT_BY_FIELDS.find(i => i.id == this.sort.field)?.field;
                params.append(`sort`, `${(this.sort.direction === "asc" ? "" : "-")}${sortFieldName}`);
            } else {
                params.append(`sort`, this.sort.field);
                params.append(`direction`, this.sort.direction);
            }
        }

        if (this.pagination.size) {
            params.append(toApiString ? "page[number]" : "number", this.pagination.number!.toString() ?? 1);
            params.append(toApiString ? "page[size]" : "size", this.pagination.size.toString());
        }

        // filter out sold cars based on last-seen date
        if (filterOutSoldCars && toApiString) {
            params.append("filter[last-seen-at][gte]", `'-3 days'`);
        }

        const queryString = decodeURIComponent(params.toString());
        return queryString ? `?${queryString}` : "";
    }

    toApiString() {
        return this.toString(true);
    }
}